import React from "react";

// Fallback bubble for an unknown / legacy custom share attachment (design frame
// 1c-b / 1d). Any share type this build doesn't recognize must still render a
// minimal, readable text bubble with a link — an EMPTY bubble may never occur.
// CustomAttachment routes here only for non-native custom types (stream's own
// image/file/video/link-preview attachments still go to the default renderer).
//
// The line + href are read tolerantly from whatever the (possibly old) payload
// carries; the text line ALWAYS renders, so output is never empty even when the
// attachment is otherwise blank.
const FallbackShareCard = (props) => {
  const att = props.attachments?.[0] || {};
  // Some custom shares carry no top-level line and put their label inside
  // `metadata` (e.g. player_share → metadata.name; agent_tender_views.py:981).
  // FallbackShareCard is that type's DESIGNATED renderer (no dedicated card
  // exists), so read a label out of metadata as well before the generic
  // default — otherwise the bubble would show a meaningless catch-all line.
  const meta = att.metadata || {};
  const line =
    att.fallback ||
    att.title ||
    att.text ||
    att.pretext ||
    meta.label ||
    meta.name ||
    meta.list_name ||
    meta.title ||
    "Shared an item from TransferPitch.";
  const href = att.og_scrape_url || att.title_link || att.link || "/inbox";

  return (
    <div className="max-w-[340px] bg-white border border-[#E4E9F0] rounded-[14px] px-[13px] py-[9px]">
      <div className="text-[13px] leading-[1.45] text-[#111827]">{line}</div>
      <a
        href={href}
        className="text-[13px] font-semibold text-[#2283FF] hover:underline"
      >
        Open in TransferPitch
      </a>
    </div>
  );
};

export default FallbackShareCard;
